// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import 'es6-promise/auto';
import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import VeeValidate from 'vee-validate';
import VueVideoPlayer from 'vue-video-player';
import VueAnalytics from 'vue-analytics';
import VueCarousel from 'vue-carousel';
import VueClipboards from 'vue-clipboards';
import Autocomplete from 'v-autocomplete';
import 'flatpickr/dist/flatpickr.min.css';
import '@/assets/styles/main.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { GA_ID } from './config';
import AppRoot from './AppRoot';

import httpPlugin from './plugins/http';

import MyComponents from './components';
import MyFilters from './filters';
import router from './router';
import i18n from './i18n';
import store from './store';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueCarousel);
Vue.use(VueClipboards);
Vue.use(VeeValidate, { errorBagName: 'veeErrors' });
Vue.use(httpPlugin, { store, router });
Vue.use(VueVideoPlayer);
Vue.use(Autocomplete);
Vue.use(VueAnalytics, {
  id: GA_ID,
  router,
  autoTracking: {
    pageviewOnLoad: false,
  },
  ignoreRoutes: ['auth'],
});

Vue.use(MyComponents);
Vue.use(MyFilters);

sync(store, router);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  el: '#app',
  template: '<AppRoot/>',
  components: { AppRoot },
});



// WEBPACK FOOTER //
// ./src/main.js